$(function () {
    $('.readmore01-btn').on('click', function () {
        // クリックされた要素に対応する.readmore-content01を探す
        const t = $(this).siblings('.readmore-content01');
        t.toggleClass('is_open');
        if (t.hasClass('is_open')) {
            const h = t.get(0).scrollHeight;
            t.css('height', h);
            $(this).text('Close')
        } else {
            t.css('height', '');
            $(this).text('More');
        }
    });
});